export const messages = {
  en: {
    reportCustomManage: {
      queryCondition: 'Query Conditions',
      reportInfo: 'Report Information',
      enterReportId: 'Please enter report ID',
      enterGroupId: 'Please enter group ID',
      enterTitle: 'Please enter title',
      query: 'Query',
      reset: 'Reset',
      addReport: 'Add Report',
      reportId: 'Report ID',
      reportGroup: 'Report Group',
      title: 'Title',
      sort: 'Sort',
      description: 'Description',
      operation: 'Operation',
      relateComponent: 'Relate Component',
      edit: 'Edit',
      delete: 'Delete'
    },
    addReportCustom: {
      addReport: 'Add Report',
      reportGroup: 'Report Group',
      groupRequired: 'Report group is required',
      groupMaxLength: 'Report group cannot exceed 30 characters',
      selectGroup: 'Required, please select report group',
      title: 'Title',
      titleRequired: 'Title is required',
      titleMaxLength: 'Title cannot exceed 64 characters',
      inputTitle: 'Required, please enter title',
      sort: 'Sort',
      sortRequired: 'Sort is required',
      sortMaxLength: 'Sort cannot exceed 11 characters',
      inputSort: 'Required, please enter sort',
      description: 'Description',
      descriptionMaxLength: 'Description cannot exceed 512 characters',
      inputDescription: 'Optional, please enter description',
      cancel: 'Cancel',
      save: 'Save',
      addSuccess: 'Added successfully'
    },
    editReportCustom: {
      editReport: 'Edit Report',
      reportGroup: 'Report Group',
      groupRequired: 'Report group is required',
      groupMaxLength: 'Report group cannot exceed 30 characters',
      selectGroup: 'Required, please select report group',
      title: 'Title',
      titleRequired: 'Title is required',
      titleMaxLength: 'Title cannot exceed 64 characters',
      inputTitle: 'Required, please enter title',
      sort: 'Sort',
      sortRequired: 'Sort is required',
      sortMaxLength: 'Sort cannot exceed 11 characters',
      inputSort: 'Required, please enter sort',
      description: 'Description',
      descriptionMaxLength: 'Description cannot exceed 512 characters',
      inputDescription: 'Optional, please enter description',
      cancel: 'Cancel',
      save: 'Save',
      editSuccess: 'Modified successfully'
    },
    deleteReportCustom: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteReport: 'Confirm to delete report?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    reportCustomManage: {
      queryCondition: '查询条件',
      reportInfo: '报表信息',
      enterReportId: '请输入报表编号',
      enterGroupId: '请输入组编号',
      enterTitle: '请输入选项标题',
      query: '查询',
      reset: '重置',
      addReport: '添加报表',
      reportId: '报表编号',
      reportGroup: '报表组',
      title: '选项标题',
      sort: '排序',
      description: '描述',
      operation: '操作',
      relateComponent: '关联组件',
      edit: '修改',
      delete: '删除'
    },
    addReportCustom: {
      addReport: '添加报表',
      reportGroup: '报表组',
      groupRequired: '报表组不能为空',
      groupMaxLength: '报表组不能超过30',
      selectGroup: '必填，请选择报表组',
      title: '选项标题',
      titleRequired: '选项标题不能为空',
      titleMaxLength: '选项标题不能超过64',
      inputTitle: '必填，请填写选项标题',
      sort: '排序',
      sortRequired: '排序不能为空',
      sortMaxLength: '排序不能超过11',
      inputSort: '必填，请填写排序',
      description: '描述',
      descriptionMaxLength: '描述不能超过512',
      inputDescription: '选填，请填写描述',
      cancel: '取消',
      save: '保存',
      addSuccess: '添加成功'
    },
    editReportCustom: {
      editReport: '修改报表',
      reportGroup: '报表组',
      groupRequired: '报表组不能为空',
      groupMaxLength: '报表组不能超过30',
      selectGroup: '必填，请选择报表组',
      title: '选项标题',
      titleRequired: '选项标题不能为空',
      titleMaxLength: '选项标题不能超过64',
      inputTitle: '必填，请填写选项标题',
      sort: '排序',
      sortRequired: '排序不能为空',
      sortMaxLength: '排序不能超过11',
      inputSort: '必填，请填写排序',
      description: '描述',
      descriptionMaxLength: '描述不能超过512',
      inputDescription: '选填，请填写描述',
      cancel: '取消',
      save: '保存',
      editSuccess: '修改成功'
    },
    deleteReportCustom: {
      confirmOperation: '请确认您的操作',
      confirmDeleteReport: '确定删除报表？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}